import nextAvailable from './nextAvailable';
import numberInLine from './numberInLine';

export const VERSION_ONE = '/v1';

export default {
  path: VERSION_ONE,
  children: [nextAvailable, numberInLine],
};
